import {Component, OnDestroy, OnInit} from '@angular/core';
import {DocumentService} from '../../../user/service/document.service';
import {ActivatedRoute, Router} from '@angular/router';
import {LocalStorage} from '../../../global/util/LocalStorage';
import {Resource} from '../../../user/model/Resource';
import {Subject} from 'rxjs';
import {Constant} from '../../../global/util/Constant';
import {UanatacaService} from '../../../user/service/uanataca.service';
import {TypeSignature} from '../../../global/util/TypeSignature';
import {PublicService} from '../../../user/service/public.service';

@Component({
    selector: 'app-signed-document-viewer',
    templateUrl: './signed-document-viewer.component.html',
    styleUrls: ['./signed-document-viewer.component.css']
})
export class SignedDocumentViewerComponent implements OnInit, OnDestroy {
    public alertType: any;
    public showError: any;
    public messageAlert: any;
    public urlStream: any;
    public reloadingPdf: boolean;
    public resource: Resource;
    public document: any;
    public person: any;
    private hashIdentifier: any;
    public personId: number;
    public signatureDescriptions: any[] = [];
    public selectedSignatureDescriptions: any[] = [];
    public resourceList: any[] = [];
    public icon: any;
    public eventsSubject: Subject<void> = new Subject<void>();
    private rubricSrc: string | ArrayBuffer;
    public activeIndex: number;
    public loading: boolean;
    isSuccessfully = true;
    private signCompleted = true;

    constructor(private activatedRoute: ActivatedRoute,
                private route: Router,
                private uanatacaService: UanatacaService,
                private publicService: PublicService,
                private documentService: DocumentService) {
        this.receiveParams();
    }

    ngOnInit(): void {
        LocalStorage.removeItem('termConditionAccepted');
        if (!this.document) {
            this.back();
        }
        if (this.document) {
            this.person.documentId = this.document.id;
            this.resourceList = this.document._more.resources;
            this.resource = this.resourceList[0];
            this.setUrlDoc(this.resource);
            if (this.isElectronicSignature) {
                this.isDocumentFinished(this.document.id);
            }
        }
        // Espera un segundo para limpiar el hash de la URL para evitar regresar desde el visor de documentos firmados.
        setTimeout(() => {
            this.hashIdentifier = '';
            this.personId = 0;
            this.reloadPdf();
        }, 100);
    }

    public receiveParams() {
        this.activatedRoute.params.subscribe(params => {
            this.hashIdentifier = params.hashIdentifier;
            this.personId = +params.personId;
        });
        this.document = history.state.document;
        this.person = history.state.person;
    }

    public setUrlDoc(resource: any) {
        this.resource = resource;
        this.getStream();
    }

    /**
     * Obtiene el pdf desde el API y crea un objeto con este mismo.
     */
    public getStream(): void {
        this.reloadingPdf = true;
        const url = this.resource.url;
        this.documentService.download(url).subscribe(value => {
            const file = new Blob([value], {type: 'application/pdf'});
            this.urlStream = URL.createObjectURL(file);
            this.reloadingPdf = false;
        }, () => {
            this.reloadingPdf = false;
        });
    }

    private reloadPdf() {
        this.reloadingPdf = true;
        this.documentService.download(this.resource.url).subscribe(value => {
            const file = new Blob([value], {type: 'application/pdf'});
            this.urlStream = URL.createObjectURL(file);
            this.reloadingPdf = false;
        }, () => {
            this.reloadingPdf = false;
        });
    }


    private isDocumentFinished(documentId: number) {
        this.loading = true;
        const url = Constant.ROOT_API_V1.concat('/public/verify/document/have-manifest-and-traceability/?documentId=').concat(String(documentId));
        if (this.signCompleted) {
            const interval = setInterval(() => {
                this.publicService.get(url).subscribe((next2: any) => {
                    if (next2.hasConfManifestAndTraceability) {
                        if (next2.documentIsReady) {
                            this.loading = false;
                            this.reloadPdf();
                            clearInterval(interval);
                        }
                    } else {
                        this.loading = false;
                        this.getStream();
                        clearInterval(interval);
                    }
                });
            }, 500);
        }
        setTimeout(() => {
            this.loading = false;
        }, 5000);
    }


    /**
     * Devuelve lista de las descripciones para ser enviadas al formulario del visor de PDF
     */
    public getListSignatureDescription(): any {
        this.selectedSignatureDescriptions = LocalStorage.getSelectedSignatureDescriptions();
        if (this.selectedSignatureDescriptions) {
            return this.selectedSignatureDescriptions;
        } else {
            return this.signatureDescriptions;
        }
    }

    public downloadContract() {
        this.loading = true;
        const url = Constant.ROOT_API_V1.concat('/uanataca/public/uanatacarequests/', String(this.document._more.uanatacaRequestId), '/contract/stream?uuid=', this.document._more.uuid);
        this.uanatacaService.get(url).subscribe(next => {
            const control = document.createElement('a');
            control.setAttribute('style', 'display:none;');
            document.body.appendChild(control);
            control.href = window.URL.createObjectURL(next);
            control.download = 'contrato.pdf';
            control.click();
            this.loading = false;
        }, () => {
            this.loading = false;
        });
    }

    ngOnDestroy(): void {
        LocalStorage.removeItem('documentSigned');
    }

    back() {
        this.route.navigate(['document/' + this.hashIdentifier + '/people/' + this.personId + '/sign']).then();
    }

    toggle(index: number, resource: any): void {
        if (this.activeIndex === index) {
            // Si el panel ya está abierto, se cierra (sin acción adicional)
            this.activeIndex = null;
        } else {
            // Si el panel no está abierto, se expande y ejecuta la lógica
            this.activeIndex = index;
            this.setUrlDoc(resource);
        }
    }

    get typeSignature(): number {
        return this.document._more.typeSignature;
    }

    get defaultRubricSrc(): string | ArrayBuffer {
        return this.rubricSrc || this.placeHoldItRubric;
    }

    get isCloudSignature(): boolean {
        return TypeSignature.CLOUD === this.document._more.typeSignature;
    }

    get placeHoldItRubric(): string {
        return Constant.DEFAULT_IMAGE;
    }

    get isTypeSignatureAnyThing() {
        return TypeSignature.ANYTHING === this.document._more.typeSignature;
    }

    get isElectronicSignature(): boolean {
        return TypeSignature.ELECTRONIC === this.document._more.typeSignature;
    }
}
